import { IMIUIColumn } from "../../../reducer/General/_interfaces";
import { ISelectedFilters } from "../../../reducer/mappingFiles/_interfaces";

export const cust_planning_level_label = 'Cust. Planning Level';
export const cust_planning_level_name_label = 'Cust. Planning Level Name';
export const gkc_label = 'GKC';
export const buyng_group_cust_name_label = 'Buying Group or Customer Name';
export const country_label = 'Country';

export const IKA_MAP_COLUMNS:IMIUIColumn[] = [
    {
        id: 'country',
        label: country_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'cust_planning_level',
        label: cust_planning_level_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'cust_planning_level_name',
        label: cust_planning_level_name_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'gkc',
        label: gkc_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'buyng_group_cust_name',
        label: buyng_group_cust_name_label,
        minWidth: '10%',
        align: 'left',
        group: ''
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
        // format: (value) => value.toFixed(2),
    },
]


export const INITIAL_FILTERS:ISelectedFilters = {
        buyng_group_cust_name: null,
        cust_planning_level: null,
        cust_planning_level_name:  null,
        gkc: null,
        selected_country: null,
}